import styled from 'styled-components/macro';
import StyledFlexContainer from './StyledFlexContainer';

const WorkImg = styled(StyledFlexContainer)`
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 230px;
	position: relative;
	@media screen and (min-width: 2000px) {
		height: 350px;
	}
	img {
		width: 100%;
		height: 100%;
		border-radius: 0.5rem;
		object-fit: cover;
	}
`;

export default WorkImg;
